import { CHART_GREEN, CHART_RED } from 'HubStyleTokens/colors';
import { fromJS, List } from 'immutable';
import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import * as dateRangePresets from 'UIComponents/dates/dateRangePresets';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { now, toMomentPortalTz } from 'UIComponents/core/SimpleDate';
import * as ChartTypes from 'reporting-data/constants/chartTypes';
import * as CompareTypes from 'reporting-data/constants/compareTypes';
import * as ConfigTypes from 'reporting-data/constants/configTypes';
import * as DataTypes from 'reporting-data/constants/dataTypes';
import { RANGE_TYPES as RangeTypes } from 'reporting-data/constants/dateRangeTypes';
import * as Frequency from 'reporting-data/constants/frequency';
import * as Operators from 'reporting-data/constants/operators';
import * as SortOrder from 'reporting-data/constants/sortOrder';
import fromJSOrdered from 'reporting-data/lib/fromJSOrdered';
import { colorAssignmentSets } from 'reporting-ui-components/constants/colorAssignmentSets';
import * as ReportConstants from '../constants/insights/ReportConstants';
import TableConstants from '../constants/manage/TableConstants';
import * as SharedConstants from '../constants/SharedConstants';
import UICustomDataWellHeader from '../components/insights/articlePerformance/charts/UICustomDataWellHeader';
import NewRelicPageActionTrigger from '../components/utility/NewRelicPageActionTrigger';
import { getReportRhumbConfig } from './reportRhumbConfig';
import { SCREENS } from '../constants/TrackingConstants';
import SearchTermCellContent from '../components/insights/dashboard/SearchTermCellContent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getShouldCallSCPEndpoints } from '../migration-handler/singleton/migrationHandler';
import { jsx as _jsx } from "react/jsx-runtime";
export const REPORTING_DATE_FORMAT = 'YYYYMMDD';
export function getDateFromSimpleDate(simpleDate) {
  return toMomentPortalTz(simpleDate).valueOf();
}
export function getAllTimeRange() {
  return {
    presetId: RangeTypes.CUSTOM,
    getValue: tz => ({
      startDate: SharedConstants.MIN_CUSTOM_DATE,
      endDate: now(tz)
    })
  };
}
export function getThisMonthTimeRange() {
  return dateRangePresets.LAST_THREE_MONTHS.getValue();
}
export function createReportingDateRange(dateRange = getAllTimeRange()) {
  const startDate = SimpleDate.maxDate([SharedConstants.MIN_CUSTOM_DATE, dateRange.startDate]);
  return {
    rangeType: 'CUSTOM',
    startDate: SimpleDate.toMoment(startDate).format(REPORTING_DATE_FORMAT),
    endDate: SimpleDate.toMoment(dateRange.endDate).format(REPORTING_DATE_FORMAT)
  };
}
export function getArticleDataWellReport(analyticsPageId, dateRange, metrics, navMarkerName) {
  return fromJSOrdered({
    chartType: ChartTypes.DATA_WELL,
    config: {
      compare: CompareTypes.PRIOR_PERIOD,
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.ANALYTICS_KNOWLEDGE_ARTICLES,
      dimensions: List.of(),
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: createReportingDateRange(dateRange)
        },
        custom: [{
          operator: Operators.EQ,
          property: 'filters',
          value: analyticsPageId
        }]
      },
      frequency: Frequency.DAY,
      metrics
    },
    displayParams: {
      render: {
        header: UICustomDataWellHeader.withProps()
      },
      rhumbConfig: getReportRhumbConfig(navMarkerName, null,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof NewRelicPageActionTrigger... Remove this comment to see the full error message
      NewRelicPageActionTrigger)
    }
  });
}
export function getArticleViewsReport(analyticsPageId, dateRange, navMarkerName) {
  return fromJSOrdered({
    chartType: ChartTypes.AREA,
    config: {
      configType: ConfigTypes.TIME_SERIES,
      dataType: DataTypes.ANALYTICS_KNOWLEDGE_ARTICLES_SOURCES,
      dimensions: List.of('sessionDate', 'breakdown'),
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: createReportingDateRange(dateRange)
        },
        custom: [{
          operator: Operators.EQ,
          property: 'pageId',
          value: analyticsPageId
        }, {
          operator: Operators.IN,
          property: 'filters',
          values: List.of('direct', 'organic', 'email', 'paid', 'social', 'paid-social', 'other', 'referrals', 'offline')
        }]
      },
      frequency: Frequency.DAY,
      metrics: [ReportConstants.VIEWS_METRIC],
      processors: List.of()
    },
    displayParams: {
      colors: {
        custom: colorAssignmentSets.get('sources')
      },
      rhumbConfig: getReportRhumbConfig(navMarkerName, null,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof NewRelicPageActionTrigger... Remove this comment to see the full error message
      NewRelicPageActionTrigger),
      stacked: true
    }
  });
}
export function getArticleDetailsTableReport(dateRange, onSort, onRedirect, metrics, sort, maxFeedbackCount, navMarkerName, knowledgeBaseId) {
  return fromJSOrdered({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.KNOWLEDGE_ARTICLES,
      dimensions: List.of('id'),
      limit: TableConstants.NUM_ROWS_PER_PAGE,
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: createReportingDateRange(dateRange)
        },
        custom: {
          knowledgeBaseId,
          knowledgeBaseIsLegacy: !getShouldCallSCPEndpoints(knowledgeBaseId)
        }
      },
      metrics,
      processors: List.of(),
      sort
    },
    displayParams: {
      columns: {
        helpfulFeedback: {
          showAsBarChart: true,
          showAsBarChartOptions: {
            color: CHART_GREEN,
            max: maxFeedbackCount
          }
        },
        unhelpfulFeedback: {
          showAsBarChart: true,
          showAsBarChartOptions: {
            color: CHART_RED,
            max: maxFeedbackCount
          }
        }
      },
      onSort,
      resetOffsetOnSortChange: true,
      resetOffsetOnFilterChange: true,
      rhumbConfig: getReportRhumbConfig(navMarkerName, null,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof NewRelicPageActionTrigger... Remove this comment to see the full error message
      NewRelicPageActionTrigger)
    }
  });
}
export function getArticleSearchWithNoResultsReport(dateRange, knowledgeBaseId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  return fromJS({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS,
      dimensions: ['{properties.hs_term}'],
      unifiedEvent: {
        reportType: 'e_knowledgebase_site_search_report',
        schemaVersion: 2
      },
      metrics: [{
        property: 'total_searches'
      }],
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: {
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01',
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD')
          }
        },
        custom: [{
          property: '{properties.hs_knowledge_base_id}',
          operator: Operators.EQ,
          value: knowledgeBaseId
        }, {
          property: 'total_search_results_found',
          operator: Operators.EQ,
          value: 0
        }, {
          property: 'total_searches',
          operator: Operators.GTE,
          value: 1
        }]
      },
      sort: [{
        property: 'total_searches',
        order: SortOrder.DESC
      }],
      limit: 5
    },
    displayParams: {
      columns: {
        '{properties.hs_term}': {
          render: args => /*#__PURE__*/_jsx(SearchTermCellContent, Object.assign({}, args, {
            usageTrackerObj: {
              action: 'tag-articles-search-no-results',
              screen: SCREENS.INSIGHTS
            }
          }))
        }
      }
    }
  });
}
export function getArticleTopSearchTermsReport(dateRange, onSort, order, getSearchTermUrl, knowledgeBaseId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  return fromJS({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS,
      dimensions: ['{properties.hs_term}'],
      unifiedEvent: {
        reportType: 'e_knowledgebase_site_search_report',
        schemaVersion: 2
      },
      metrics: [{
        property: 'total_search_results_found'
      }, {
        property: 'total_searches'
      }, {
        property: 'total_search_conversions'
      }, {
        property: 'total_search_conversions_per_search'
      }],
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: {
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01',
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD')
          }
        },
        custom: [{
          property: '{properties.hs_knowledge_base_id}',
          operator: Operators.EQ,
          value: knowledgeBaseId
        }]
      },
      sort: [{
        property: 'total_search_results_found',
        order: order.get('order') || SortOrder.ASC
      }],
      limit: 5
    },
    displayParams: {
      columns: {
        '{properties.hs_term}': {
          render: args => /*#__PURE__*/_jsx(SearchTermCellContent, Object.assign({}, args, {
            usageTrackerObj: {
              action: 'tag-articles-most-searched-terms',
              screen: SCREENS.INSIGHTS
            },
            getSearchTermUrl: getSearchTermUrl
          }))
        },
        total_search_results_found: {
          render: args => /*#__PURE__*/_jsx("td", {
            className: "text-left",
            children: args.row.get('total_search_results_found') > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.insights.dashboard.rowValues.trueValue"
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.insights.dashboard.rowValues.falseValue"
            })
          })
        },
        total_search_conversions: {
          tooltipI18nKey: 'knowledgeContentUI.insights.dashboard.tooltips.totalResultClicks'
        },
        total_search_conversions_per_search: {
          tooltipI18nKey: 'knowledgeContentUI.insights.dashboard.tooltips.avgResultClicks'
        }
      }
    }
  });
}
export function getArticleTotalSearchesReport(dateRange, currentKnowledgeBaseId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  const displayParams = {
    render: {
      header: () => null
    }
  };
  return fromJS({
    chartType: ChartTypes.DATA_WELL,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS,
      dimensions: ['{properties.hs_knowledge_base_id}'],
      metrics: [{
        property: 'total_searches'
      }],
      unifiedEvent: {
        reportType: 'e_knowledgebase_site_search_report',
        schemaVersion: 2
      },
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: {
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01',
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD')
          }
        },
        custom: [{
          property: '{properties.hs_knowledge_base_id}',
          operator: Operators.EQ,
          value: currentKnowledgeBaseId
        }]
      }
    },
    displayParams
  });
}